import { SUBSCRIBE_REQUEST, SUBSCRIBE_SUCCESS, SUBSCRIBE_FAIL, SUBSCRIBE_RESET } from '../constants/subscribersConstants'


export const createSubscribeReducer = (state = {}, action) => {
    switch (action.type) {
        case SUBSCRIBE_REQUEST:
            return { loading: true }
        case SUBSCRIBE_SUCCESS:
            return { loading: false, success: true }
        case SUBSCRIBE_FAIL:
            return { loading: false, error: action.payload }
        case SUBSCRIBE_RESET:
            return {}
        default:
            return state
    }
}
